<template>
    <div class="viridis-scale">
      <div class="gradient"></div>
      <div class="labels">
        <span>Low</span>
        <span>High</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ScaleLegend",
  };
  </script>
  
  <style scoped>
  .viridis-scale {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px; /* Adjust width as needed */
    margin: 20px auto;
  }
  
  .gradient {
    width: 100%;
    height: 20px;
    background: linear-gradient(to right, #440154, #482878, #3e4a89, #31688e, #26838f, #1f9d8a, #6cce5a, #b6de2b, #fee825);
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  
  .labels {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    color: #d8d8d8;
  }
  
  .labels span:first-child {
    text-align: left;
  }
  
  .labels span:last-child {
    text-align: right;
  }
  </style>
  